export default __webpack_public_path__ + "resources/icons/d122-27f3.webp";